(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
constructor() {
super();
this.elements = {
input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
button: this.querySelector('button'),
panel: this.querySelector('.disclosure__list-wrapper'),
};
this.elements.button.addEventListener('click', this.openSelector.bind(this));
this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
}

hidePanel() {
this.elements.button.setAttribute('aria-expanded', 'false');
this.elements.panel.setAttribute('hidden', true);
}

onContainerKeyUp(event) {
if (event.code.toUpperCase() !== 'ESCAPE') return;

this.hidePanel();
this.elements.button.focus();
}

onItemClick(event) {
event.preventDefault();
const form = this.querySelector('form');
this.elements.input.value = event.currentTarget.dataset.value;
if (form) form.submit();
}

openSelector() {
this.elements.button.focus();
this.elements.panel.toggleAttribute('hidden');
this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') ===
'false').toString());
}

closeSelector(event) {
const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
if (event.relatedTarget === null || shouldClose) {
this.hidePanel();
}
}
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function initResponsiveDots(root) {
    const sliderComponent = root.querySelector('slider-component');
    if (!sliderComponent) return;

    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll('[id^="Slide-"]'));
    const buttons = sliderComponent.querySelector('.recommendations-slider-buttons');
    const dotsWrapper = sliderComponent.querySelector('.slider-counter__wrapper');
    if (!buttons || !dotsWrapper) return;

    const getCols = () => {
      const w = window.innerWidth;
      if (w <= 749) return 2;
      if (w <= 1023) return 3;
      return 4;
    };

    const itemOffset = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0]?.clientWidth || 0);

    const updateActive = () => {
      const offset = itemOffset();
      const page = offset ? Math.round(slider.scrollLeft / offset) + 1 : 1;
      const dots = Array.from(dotsWrapper.querySelectorAll('.slider-counter__link'));
      dots.forEach((d) => {
        d.classList.remove('slider-counter__link--active');
        d.removeAttribute('aria-current');
      });
      if (dots[page - 1]) {
        dots[page - 1].classList.add('slider-counter__link--active');
        dots[page - 1].setAttribute('aria-current', 'true');
      }
    };

    const rebuild = () => {
      if (!slides.length) {
        buttons.hidden = true;
        return;
      }

      const cols = getCols();
      const totalPages = Math.max(1, slides.length - cols + 1);
      dotsWrapper.innerHTML = '';
      for (let i = 0; i < totalPages; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'slider-counter__link slider-counter__link--dots link';
        btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
        btn.innerHTML = '<span class="dot"></span>';
        btn.addEventListener('click', () => {
          const offset = itemOffset();
          slider.scrollTo({ left: i * offset, behavior: 'smooth' });
        });
        dotsWrapper.appendChild(btn);
      }
      buttons.hidden = false;
      updateActive();
    };

    rebuild();
    slider.addEventListener('scroll', updateActive, { passive: true });
    window.addEventListener('resize', rebuild);
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            initResponsiveDots(this);
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }

    connectedCallback() {
      initResponsiveDots(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.storageKey = 'recently_viewed_products';
      this.sectionId = this.dataset.sectionId;
      this.heading = this.dataset.heading;
      this.currentHandle = this.dataset.currentHandle;
      this.limit = Number(this.dataset.limit || 4);

      this.updateStorage();
      this.renderSkeleton();
      this.loadProducts();
    }

    updateStorage() {
      if (!this.currentHandle) return;
      let handles = [];
      try {
        handles = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
        if (!Array.isArray(handles)) handles = [];
      } catch (e) {
        handles = [];
      }

      handles = handles.filter((h) => h && h !== this.currentHandle);
      handles.unshift(this.currentHandle);
      handles = handles.slice(0, 10);

      try {
        localStorage.setItem(this.storageKey, JSON.stringify(handles));
      } catch (e) {}
    }

    getDesiredColumns() {
      const w = window.innerWidth;
      if (w <= 749) return 2;
      if (w <= 1023) return 3;
      return 4;
    }

    shouldShowDots() {
      return true;
    }

    renderSkeleton() {
      this.innerHTML = `
        <h2 class="product-recommendations__heading h1">${this.heading || ''}</h2>
        <slider-component class="slider-mobile-gutter">
          <ul id="Slider-${
            this.sectionId
          }" class="grid product-grid slider slider--everywhere recommendations-slider" role="list"></ul>
          <div class="slider-buttons no-js-hidden recommendations-slider-buttons" hidden>
            <div class="slider-counter slider-counter--dots" aria-label="Dots">
              <div class="slider-counter__wrapper"></div>
            </div>
          </div>
        </slider-component>
      `;

      this.slider = this.querySelector(`#Slider-${this.sectionId}`);
      this.buttons = this.querySelector('.recommendations-slider-buttons');
      this.dotsWrapper = this.querySelector('.slider-counter__wrapper');
    }

    async loadProducts() {
      let handles = [];
      try {
        handles = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
        if (!Array.isArray(handles)) handles = [];
      } catch (e) {
        handles = [];
      }

      handles = handles.filter((h) => h && h !== this.currentHandle).slice(0, this.limit);
      if (!handles.length) {
        this.remove();
        return;
      }

      const htmlParts = await Promise.all(
        handles.map(async (handle, idx) => {
          const url = `/products/${handle}?section_id=recently-viewed-card`;
          const res = await fetch(url);
          const text = await res.text();
          const tmp = document.createElement('div');
          tmp.innerHTML = text;
          const sectionRoot = tmp.querySelector('.shopify-section');
          const inner = sectionRoot ? sectionRoot.innerHTML : tmp.innerHTML;

          return `
            <li id="Slide-${this.sectionId}-${idx + 1}" class="grid__item slider__slide">
              ${inner}
            </li>
          `;
        })
      );

      this.slider.innerHTML = htmlParts.join('');
      this.buttons.hidden = false;
      this.initDots();
    }

    initDots() {
      const slides = Array.from(this.slider.querySelectorAll('[id^="Slide-"]'));
      if (!slides.length) {
        this.buttons.hidden = true;
        return;
      }

      const rebuild = () => {
        const cols = this.getDesiredColumns();
        const totalPages = Math.max(1, slides.length - cols + 1);

        this.dotsWrapper.innerHTML = '';
        for (let i = 0; i < totalPages; i++) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'slider-counter__link slider-counter__link--dots link';
          btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
          btn.innerHTML = '<span class="dot"></span>';
          btn.addEventListener('click', () => {
            const itemOffset = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].clientWidth;
            this.slider.scrollTo({ left: i * itemOffset, behavior: 'smooth' });
          });
          this.dotsWrapper.appendChild(btn);
        }
        this.updateActiveDot();
      };

      this.updateActiveDot = () => {
        const itemOffset = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].clientWidth;
        const currentPage = Math.round(this.slider.scrollLeft / itemOffset) + 1;
        const dots = Array.from(this.dotsWrapper.querySelectorAll('.slider-counter__link'));
        dots.forEach((d) => {
          d.classList.remove('slider-counter__link--active');
          d.removeAttribute('aria-current');
        });
        if (dots[currentPage - 1]) {
          dots[currentPage - 1].classList.add('slider-counter__link--active');
          dots[currentPage - 1].setAttribute('aria-current', 'true');
        }
      };

      rebuild();
      this.slider.addEventListener('scroll', () => this.updateActiveDot(), { passive: true });
      window.addEventListener('resize', () => rebuild());
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  function initSlideshowBottomDots(slideshowEl) {
    const slider = slideshowEl.querySelector('[id^="Slider-"]');
    const dotsContainer = slideshowEl.querySelector('.slideshow-bottom-dots');
    if (!slider || !dotsContainer) return;

    const dots = Array.from(dotsContainer.querySelectorAll('.ss-dot'));
    if (!dots.length) return;

    const getSlideWidth = () =>
      slider.querySelector('.slider__slide')?.clientWidth || slider.clientWidth;

    const update = () => {
      const w = getSlideWidth();
      const current = w ? Math.round(slider.scrollLeft / w) : 0;
      dots.forEach((dot, i) => {
        dot.classList.toggle('ss-dot--active', i === current);
      });
    };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        slider.scrollTo({ left: i * getSlideWidth(), behavior: 'smooth' });
      });
    });

    slider.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initSlideshowArrows(slideshowEl) {
    const slider = slideshowEl.querySelector('[id^="Slider-"]');
    const prevBtn = slideshowEl.querySelector('.slideshow-arrow--prev');
    const nextBtn = slideshowEl.querySelector('.slideshow-arrow--next');
    if (!slider || !prevBtn || !nextBtn) return;

    const getSlideWidth = () =>
      slider.querySelector('.slider__slide')?.clientWidth || slider.clientWidth;

    const slideCount = () => slider.querySelectorAll('.slider__slide').length;

    prevBtn.addEventListener('click', () => {
      const w = getSlideWidth();
      const current = w ? Math.round(slider.scrollLeft / w) : 0;
      slider.scrollTo({ left: Math.max(0, current - 1) * w, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      const w = getSlideWidth();
      const current = w ? Math.round(slider.scrollLeft / w) : 0;
      slider.scrollTo({ left: Math.min(slideCount() - 1, current + 1) * w, behavior: 'smooth' });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('slideshow-component').forEach(el => {
      initSlideshowBottomDots(el);
      initSlideshowArrows(el);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
